import { AnimatePresence, motion } from 'motion/react';
import useLocalStorage from './hooks/useLocalStorage';
import { useController } from './hooks/useController';

import { VoteFullSize } from './components/VoteFullSize/VoteFullSize';
import { QuestionSpeaker } from './components/QuestionSpeaker/QuestionSpeaker';
import { EmptyPage } from './components/EmptyPage/EmptyPage';

import { getOrCreateUserId } from './helpers/userId';

import logo from './assets/images/logo.png';
import { useVotes } from './context/VotesContext';
import { AdvtVote } from './components/AdvtVote/AdvtVote';
import { MadeIactivePro } from './components/MadeIactivePro/MadeIactivePro';

const STORAGE_KEY = 'vote_authorId';

function App() {
  const { votes, setVote } = useVotes();

  const [authorId, setUserId] = useLocalStorage(
    STORAGE_KEY,
    getOrCreateUserId(STORAGE_KEY),
  );

  const { isActive, voteState, idVote, currentState } = useController(authorId);

  return (
    <div className="app-wrapper">
      <motion.div
        style={{ width: '100%' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="logoBlock"
      >
        <AdvtVote
          questionImgUrl={voteState?.questionImgUrl}
          advancedSettings={voteState?.advancedSettings}
        />
      </motion.div>

      {isActive !== null ? (
        <div className="titre-wrapper">
          <AnimatePresence mode="wait">
            {!isActive ? (
              <motion.div
                style={{ width: '100%' }}
                key={`${isActive}-EmptyPage`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                exit={{ opacity: 0 }}
              >
                <EmptyPage />
              </motion.div>
            ) : currentState === 'S1' ? (
              <motion.div
                style={{ width: '100%' }}
                key={`${idVote}-vote`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                exit={{ opacity: 0 }}
              >
                <VoteFullSize
                  variants={voteState?.vars}
                  title={voteState?.title}
                  idVote={idVote}
                  authorId={authorId}
                  votes={votes}
                  setVotes={setVote}
                />
              </motion.div>
            ) : currentState === 'S2' ? (
              <motion.div
                style={{ width: '100%' }}
                key={`${idVote}-Question`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                exit={{ opacity: 0 }}
              >
                <QuestionSpeaker authorId={authorId} />
              </motion.div>
            ) : null}
          </AnimatePresence>
        </div>
      ) : null}

      <MadeIactivePro />
    </div>
  );
}

export default App;
